module.exports = "app-breadcrumb .breadcrumb {\n  background: transparent;\n  border-radius: 0;\n  margin: 20px 0;\n  padding: 0;\n}\napp-breadcrumb .breadcrumb .breadcrumb-item {\n  color: rgba(80, 2, 147, 0.6);\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: 1.9px;\n}\napp-breadcrumb .breadcrumb .breadcrumb-item a {\n  color: #500293;\n  text-decoration: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/breadcrumb/styles/breadcrumb.scss
// module id = ./src/app/system/core/breadcrumb/styles/breadcrumb.scss
// module chunks = main